import { Work } from "@/javascript/domain/entities/work"
import dayjs from "dayjs"

const workSubtitleText = (work: Work): string => {
  if (work.startTime && work.endTime) {
    return `Planejado para ${dayjs(work.startTime).format('DD/MM/YY HH:mm')} - ${dayjs(work.endTime).format('DD/MM/YY HH:mm')}`
  }
  if (work.startTime) {
    return `Planejado para iniciar ${dayjs(work.startTime).format('DD/MM/YY HH:mm')}`
  }
  if (work.endTime) {
    return `Planejado para finalizar ${dayjs(work.endTime).format('DD/MM/YY HH:mm')}`
  }
  return 'Não planejada'
}

export default workSubtitleText
